import { css, useTheme } from '@emotion/react';
import Subscription from '~/components/Subscription/Subscription';
import { HelmetHead } from '~/components/common';

export default function SubscriptionPage() {
  const theme = useTheme();
  return (
    <>
      <HelmetHead title='Subscription' />

      <div
        css={css`
          width: 100%;
          height: 100%;
          padding: 0 0 ${theme.layout.chat_navigation_height};
        `}
      >
        <Subscription />
      </div>
    </>
  );
}
